import React from "react";
import { Container, Header, SubHeader, Values, CardContainer } from "./styles";
import PropTypes from "prop-types";
import Card from "./Card";

const ValueProps = ({
	header,
	subHeader,
	bulletPoints,
	showInTabletAndMobile,
	linkColor = "#551A8B",
}) => {
	return (
		<Container showInTabletAndMobile={showInTabletAndMobile}>
			<Header>{header} </Header>
			{subHeader && <SubHeader>{subHeader}</SubHeader>}
			<Values>
				{bulletPoints.map((item, index) => (
					<CardContainer key={item.title || String(index)}>
						<Card
							image={item.image}
							title={item.title}
							description={item?.description?.value}
							isDescriptionRichText={!item?.description?.isTextContent}
							linkColor={linkColor}
						/>
					</CardContainer>
				))}
			</Values>
		</Container>
	);
};

ValueProps.defaultProps = {
	header: "",
	subHeader: "",
	bulletPoints: [],
	showInTabletAndMobile: true,
};
ValueProps.propType = {
	header: PropTypes.string,
	subHeader: PropTypes.string,
	bulletPoints: PropTypes.shape({
		image: PropTypes.shape({}),
		title: PropTypes.string,
		description: PropTypes.string,
	}),
	showInTabletAndMobile: PropTypes.bool,
};

export default ValueProps;
